/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-21",
    versionChannel: "nightly",
    buildDate: "2025-05-21T00:06:58.919Z",
    commitHash: "cdbb93377b08fb1f4fa007ce2a080596003d565b",
};
